import { connect } from 'react-redux'
import {
  handleLogin,
  clearErrorMsg,
  handlePasswordKeyDown,
  handleChange,
} from './module'
import Login from './Login'

const mapActionCreators = {
  handleLogin,
  clearErrorMsg,
  handlePasswordKeyDown,
  handleChange,
}

const mapStateToProps = state => ({
  auth: state.auth,
  errorMsg: state.login.errorMsg,
  isOutdatedBrowser: state.app.isOutdatedBrowser,
  loginIsFetching: state.login.loginIsFetching,
})

export default connect(
  mapStateToProps,
  mapActionCreators
)(Login)



// WEBPACK FOOTER //
// ./src/legacy/pages/Login/container.jsx